<template lang="pug">
.login-container
  el-form.login-form(autocomplete='on', :model='loginForm', :rules='loginRules', ref='loginForm', label-position='left')
    .title-container
      h3.title wow CMS
    el-form-item(prop='username')
      el-input(name='email', type='text', v-model='loginForm.email', placeholder='email')
    el-form-item(prop='password')
      el-input(name='password', type='password', @keyup.enter.native='handleLogin', v-model='loginForm.password', placeholder='password')
    el-button(type='primary', style='width:100%;margin-bottom:30px;', :loading='loading', @click.native.prevent='handleLogin') LOGIN
</template>

<script>
import * as api from '@/api/auth'
import { Message } from 'element-ui'
export default {
  name: 'PagesLogin',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [{required: true, trigger: 'blur'}],
        password: [{required: true, trigger: 'blur'}]
      },
      loading: false
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          api.post(this.loginForm)
            .then((res) => {
              this.loading = false
              this.$router.push({ path: '/' })
            })
            .catch((error) => {
              Message({
                message: error.response.data.error_message,
                type: 'error',
                duration: 5 * 1000
              })
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Login/index.vue